var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailNotActivated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 6.83871C78.3505 6.83871 99.1613 27.3709 99.1613 53C99.1613 78.4936 78.5148 99.1613 53 99.1613C27.5164 99.1613 6.83871 78.5251 6.83871 53C6.83871 27.5252 27.4835 6.83871 53 6.83871ZM53 0C23.731 0 0 23.7395 0 53C0 82.2776 23.731 106 53 106C82.269 106 106 82.2776 106 53C106 23.7395 82.269 0 53 0ZM50.5445 25.6452H55.4553C56.9135 25.6452 58.0784 26.8595 58.0177 28.3165L56.5217 64.2198C56.4645 65.5935 55.3344 66.6774 53.9593 66.6774H52.0404C50.6656 66.6774 49.5353 65.5933 49.4781 64.2198L47.9821 28.3165C47.9216 26.8595 49.0863 25.6452 50.5445 25.6452ZM53 70.9516C49.6952 70.9516 47.0161 73.6307 47.0161 76.9355C47.0161 80.2403 49.6952 82.9194 53 82.9194C56.3048 82.9194 58.9839 80.2403 58.9839 76.9355C58.9839 73.6307 56.3048 70.9516 53 70.9516Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailNotActivated);
export default __webpack_public_path__ + "static/media/email-not-activated.606404e931afcff82b03e55458d15a5c.svg";
export { ForwardRef as ReactComponent };